// .com / in-touch.space / localhost → международная редакция (израильская ИП).
// .ru → российская ИП.
export default function isPayplusDomain() {
  const host =
    typeof window !== "undefined" && window.location
      ? window.location.hostname.toLowerCase()
      : "";
  return !host.endsWith("wepurplay.ru");
}
